import { formatISO } from "date-fns";

export function getStatSummary(timesheetData, capacityData, draftData) {
  const todayStr = formatISO(new Date(), { representation: "date" });
  const filterPast = (data) => (data || []).filter((item) => item.date && item.date < todayStr);

  const available = filterPast(capacityData).reduce(
    (acc, cur) => acc + (cur.payroll_hours || 0),
    0
  );
  const logged = filterPast(timesheetData).reduce(
    (acc, cur) => acc + (cur.logged_hours || 0),
    0
  );
  const approved = filterPast(timesheetData).reduce(
    (acc, cur) => acc + (cur.approved_hours || 0),
    0
  );
  const unapproved = filterPast(timesheetData).reduce(
    (acc, cur) => acc + (cur.unapproved_hours || 0),
    0
  );
  const draft = filterPast(draftData).reduce(
    (acc, cur) => acc + (cur.logged_hours || 0),
    0
  );

  const reviewed = approved + unapproved;
  const unreviewed = Math.max(logged - reviewed, 0);

  const unreviewedPct =
    logged > 0 ? ((unreviewed / logged) * 100).toFixed(1) : 0;
  const unapprovedPct =
    logged > 0 ? ((unapproved / logged) * 100).toFixed(1) : 0;
  const utilization = available > 0 ? (logged / available) * 100 : 0;

  return {
    available,
    logged,
    draft,
    unreviewed: { value: unreviewed, percent: unreviewedPct },
    unapproved: { value: unapproved, percent: unapprovedPct },
    utilization,
  };
}
